<template>
  <div class="rank">
    <h4 class="title">{{ title }}</h4>
    <ul class="list" v-if="list&&list.length>0">
      <li :key="index" v-for="(item, index) in list">
        <span :class="index < 3 ? 'active' : null">{{ index + 1 }}</span>
        <a-tooltip placement="topLeft">
          <template slot="title">{{ item.name }}</template>
          <span>{{ item.name }}</span>
        </a-tooltip>
        <span class="right-bot">{{ item.total }}</span>
      </li>
    </ul>
    <a-list style="margin-top:180px" v-else :dataSource="[]"/>
  </div>
</template>

<script>
export default {
  name: 'RankList',
  // ['title', 'list']
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: null
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  font-size: 14px;
  color: #000;
}

.rank {
  // padding: 0 32px 32px 72px;
  .list {
    margin: 25px 0 0;
    padding: 0;
    list-style: none;
    padding-right: 40px;

    li {
      margin-top: 16px;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 20%;
      position: relative;

      span {
        color: rgba(0, 0, 0, .65);
        font-size: 14px;
        line-height: 22px;

        &:first-child {
          background-color: #f5f5f5;
          border-radius: 20px;
          display: inline-block;
          font-size: 12px;
          font-weight: 600;
          margin-right: 24px;
          height: 20px;
          line-height: 20px;
          width: 20px;
          text-align: center;
        }

        &.active {
          background-color: #314659;
          color: #fff;
        }

        &:last-child {
          float: right;
        }
      }

      .right-bot {
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
  }
}

.mobile .rank {
  padding: 0 32px 32px 32px;
}

</style>
